import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/FolderOpen.es.js";
const e = o.forwardRef((r, n) => /* @__PURE__ */ o.createElement(t, { ref: n, ...r, weights: a }));
e.displayName = "FolderOpenIcon";
const m = e;
export {
  e as FolderNotchOpenIcon,
  m as FolderOpen,
  e as FolderOpenIcon
};
